import { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import {
  Stack,
  Button,
  CircularProgress,
  Checkbox,
  MenuItem,
  Typography,
  IconButton,
  FormControl,
  Select,
  OutlinedInput,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Box,
  Divider,
  FormControlLabel,
  ListSubheader,
  InputAdornment,
} from '@mui/material';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import AddIcon from '@mui/icons-material/Add';
import Link from '@mui/material/Link';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import api from 'src/services/BaseService';
import { tokenService } from 'src/services';
import Services from 'src/services/Services';
import { useLocalization } from 'src/context/LocalizationContext';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 0;
const MenuProps = {
  PaperProps: {
    style: { width: 250 },
  },
};

CreateWorkOrderModal.propTypes = {
  openCreateModal: PropTypes.bool,
  onCreateModal: PropTypes.func,
  customer: PropTypes.object,
  locations: PropTypes.array,
  branches: PropTypes.array,
  handleClickOpen: PropTypes.func,
};

export default function CreateWorkOrderModal({
  openCreateModal,
  onCreateModal,
  customer,
  locations,
  branches,
}) {
  const { language } = useLocalization();
  const sentToEasyPoint = localStorage.getItem('easypointID');

  const [vehicles, setVehicles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState();
  const [selectedCustomerTitle, setSelectedCustomerTitle] = useState();
  const [selectedCar, setSelectedCar] = useState();
  const [status, setStatus] = useState(
    tokenService.getUser()?.accountCategory === 'store' ? 2 : 1
  );
  const [boxNumber, setBoxNumber] = useState();
  const [cargoList, setCargoList] = useState([]);
  const [mlDirections, setMlDirections] = useState([]);
  const [direction, setDirection] = useState();
  const [openCargoSelect, setOpenCargoSelect] = useState(false);
  const [multipleTransport, setMultipleTransport] = useState(false);
  const [from, setFrom] = useState('');
  const [to, setTo] = useState('');
  const [otherCargo, setOtherCargo] = useState('');
  const [isOtherSelected, setIsOtherSelected] = useState(false);
  const [shipmentFirmOptions, setShipmentFirmOptions] = useState([]);

  // ---- İleri tarihli rezervasyon modalı (2 adım) ----
  const [openFutureModal, setOpenFutureModal] = useState(false);
  const [futureStep, setFutureStep] = useState(1); // 1: tarih-saat, 2: kurye bilgileri
  const [futureDate, setFutureDate] = useState(''); // YYYY-MM-DD
  const [futureTime, setFutureTime] = useState(''); // HH:mm

  const [courierName, setCourierName] = useState('');
  const [courierPhone, setCourierPhone] = useState('');
  const [courierVehicleType, setCourierVehicleType] = useState('');
  const [courierPlate, setCourierPlate] = useState('');
  // ---------------------------------------------------

  // gizli native input referansları
  const dateRef = useRef(null);
  const timeRef = useRef(null);

  const vehicleTypeOptions = [
    'Otomobil',
    'Minivan',
    'Kamyonet',
    'Kamyon',
    'Motosiklet',
  ];

  const handleCargoChange = (event) => {
    setOtherCargo('');
    const value = event.target.value;
    setIsOtherSelected(value === 'Diğer');
  };

  useEffect(() => {
    const parsedUser = JSON.parse(localStorage.getItem('user'));
    let cargoFirms = [];
    Services.GetCargoFirms(parsedUser.token)
      .then((res) => {
        if (res.data.status) {
          res.data.result.map((cargoFirm) => cargoFirms.push(cargoFirm.title));
          const sortedCargoFirms = [
            ...cargoFirms.filter((cargoFirm) => cargoFirm !== 'Diğer'),
            cargoFirms.find((cargoFirm) => cargoFirm === 'Diğer'),
          ];
          setShipmentFirmOptions(sortedCargoFirms);
        }
      })
      .catch((err) => console.log(err));
  }, []);

  // yardımcılar
  const pad2 = (n) => String(n).padStart(2, '0');
  const todayStr = () => {
    const d = new Date();
    return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;
  };
  const nowHM = () => {
    const d = new Date();
    return `${pad2(d.getHours())}:${pad2(d.getMinutes())}`;
  };
  const formatTRDate = (yyyyMmDd) => {
    if (!yyyyMmDd) return '';
    const [y, m, d] = yyyyMmDd.split('-');
    return `${d}.${m}.${y}`;
  };

  const isFutureSelected = () => {
    if (!futureDate || !futureTime) return false;
    const dt = new Date(`${futureDate}T${futureTime}:00`);
    return dt.getTime() > Date.now();
  };

  function createNewJob(scheduledAt = null, courier = null) {
    if (cargoList?.length === 0) {
      toast.error('Koli adedi ve kargo adedi aynı anda sıfır olmamalıdır.');
      return;
    }

    setLoading(true);
    const objArray = [];
    cargoList?.forEach((cargo) => {
      const cargoObj = {
        customer:
          tokenService.getUser()?.accountCategory === 'store'
            ? customer?.customer?.id
            : selectedCustomer.branchID,
        type:
          cargo.cargoName === 'Transfer/Merkez Aracı (Koli)'
            ? 'accept-goods'
            : 'post-office',
        transportationTool: selectedCar,
        orderInventory: +cargo.cargoNumber,
        direction: direction.handle,
        shipmentFirm:
          cargo.cargoName === 'Transfer/Merkez Aracı (Koli)'
            ? null
            : cargo.cargoName,
        isMultipleTransportation: multipleTransport,
        isOnlyCreateJob: true,
        status:
          direction.handle === 'StoreToMallLogistics' ||
          direction.handle === 'StoreToStore'
            ? 12
            : tokenService.getUser()?.accountCategory === 'store' &&
              direction.handle === 'MallLogisticsToStore'
            ? 3
            : 5,
        from,
        to,
        sentToEasyPoint: sentToEasyPoint,
        isPhysicalBarcode: false,

        // ileri tarih bilgileri
        isScheduled: scheduledAt ? true : false,
        scheduledAt, // ISO
        courier, // {name, phone, vehicleType, plate}
      };
      objArray.push(cargoObj);
    });

    api
      .post('mall-logistics/create', objArray)
      .then((response) => {
        if (response.data.status) {
          setStatus([1]);
          setSelectedCar(null);
          setBoxNumber(null);
          setCargoList([]);
          setDirection(null);
          onCreateModal();
          toast.success(
            scheduledAt
              ? 'İleri tarihli iş kaydedildi.'
              : 'Başarıyla oluşturuldu.'
          );
          window.location.reload();
        } else {
          toast.error('İş emri oluşturulurken bir hata meydana geldi.');
        }
      })
      .catch((error) => {
        toast.error('İş emri oluşturulurken bir hata meydana geldi.');
        console.log(error);
      })
      .finally(() => setLoading(false));
  }

  const onlyActiveLocations = (arr = []) =>
    arr.filter((l) => Number(l?.locationStatus) === 1);

  const generatePermutations = (locations) => {
    const active = onlyActiveLocations(locations);
    const permutations = [];
    if (active.length >= 1) {
      for (let i = 0; i < active.length; i++) {
        const storeToMallLogistics = {
          title: `${active[i].title} → Mal Kabule`,
          handle: 'StoreToMallLogistics',
          type: 'new',
          from: active[i].locationID,
          to: sentToEasyPoint,
        };
        permutations.push(storeToMallLogistics);

        const mallLogisticsToStore = {
          title: `Mal Kabulden → ${active[i].title}`,
          handle: 'MallLogisticsToStore',
          type: 'new',
          from: sentToEasyPoint,
          to: active[i].locationID,
        };
        permutations.push(mallLogisticsToStore);

        for (let j = 0; j < active.length; j++) {
          if (i !== j) {
            const storeToStore = {
              title: `${active[i].title} → ${active[j].title}`,
              handle: 'StoreToStore',
              type: 'new',
              from: active[i].locationID,
              to: active[j].locationID,
            };
            permutations.push(storeToStore);
          }
        }
      }
    }
    setMlDirections(permutations);
  };

  const handleClose = (event, reason) => {
    if (loading) return;
    if (reason && reason === 'backdropClick') {
      setStatus(1);
      setSelectedCar(null);
      setBoxNumber(null);
      setCargoList([]);
      setDirection(null);
      onCreateModal();
    }
  };

  function capitalizeFirstLetters(str) {
    return str
      .split(' ')
      .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
      .join(' ');
  }

  const handleSubmit = (event) => {
    event.preventDefault();
    const cargoTitle =
      event?.target?.cargotitle?.value === 'Diğer'
        ? capitalizeFirstLetters(otherCargo)
        : event?.target?.cargotitle?.value;

    if (event?.target?.cargonumber?.value === '' || cargoTitle === '') {
      toast.info('Lütfen boş kısım bırakmayınız.');
    } else {
      let cargos = [];
      cargos = cargos.concat(cargoList);
      cargos.push({
        cargoName:
          event?.target?.cargotitle?.value === 'Diğer'
            ? `Diğer: ${cargoTitle}`
            : cargoTitle,
        cargoNumber: event?.target?.cargonumber?.value,
      });
      setCargoList(cargos);
      setOpenCargoSelect(false);
      setIsOtherSelected(false);
    }
  };

  useEffect(() => {
    const _vehicles = JSON.parse(
      localStorage.getItem('mallsTransportationTools')
    );
    if (_vehicles === false) {
      const mall = localStorage.getItem('mallID');
      api
        .post('flow/malls-get-default-transportation-tools', { mallID: mall })
        .then((res) => {
          if (res.data.status) setVehicles(res.data.result);
          else {
            toast.error('İş oluşturmada bir hata meydana geldi.');
            onCreateModal();
          }
        })
        .catch(() => {
          toast.error('İş oluşturmada bir hata meydana geldi.');
          onCreateModal();
        });
    } else setVehicles(_vehicles);
  }, []);

  // ileri tarih modal akışı
  const openScheduleStep1 = () => {
    setFutureStep(1);
    setFutureDate('');
    setFutureTime('');
    setCourierName('');
    setCourierPhone('');
    setCourierVehicleType('');
    setCourierPlate('');
    setOpenFutureModal(true);
  };

  const handleFutureContinue = () => {
    if (!isFutureSelected()) {
      toast.info('Lütfen bugünden sonraki bir tarih ve saat seçiniz.');
      return;
    }
    setFutureStep(2);
  };

  const handleFutureComplete = () => {
    if (!courierName || !courierPhone || !courierVehicleType || !courierPlate) {
      toast.info('Lütfen tüm alanları doldurunuz.');
      return;
    }
    const localDateTime = new Date(`${futureDate}T${futureTime}:00`);
    const scheduledAt = localDateTime.toISOString();
    const courier = {
      name: courierName,
      phone: courierPhone,
      vehicleType: courierVehicleType,
      plate: courierPlate,
    };
    setOpenFutureModal(false);
    createNewJob(scheduledAt, courier);
  };

  const disableCreate =
    selectedCar === null ||
    selectedCar === '' ||
    selectedCar === undefined ||
    direction === null ||
    direction === '' ||
    direction === undefined ||
    loading;

  // ortak stil: metin ortalı + ikon solda ama sağdaki native ikon yok
  const centeredFieldSx = {
    '& .MuiInputBase-input': {
      textAlign: 'center',
    },
    // label kullanmıyoruz, placeholder ortada görünsün
    '& .MuiInputLabel-root': { display: 'none' },
  };

  const openNativeDate = () => {
    if (dateRef.current?.showPicker) dateRef.current.showPicker();
    else dateRef.current?.click();
  };
  const openNativeTime = () => {
    if (timeRef.current?.showPicker) timeRef.current.showPicker();
    else timeRef.current?.click();
  };

  const timeMin = futureDate === todayStr() ? nowHM() : undefined;

  return (
    <>
      <Dialog
        open={openCreateModal}
        onClose={handleClose}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle>
          <Stack alignItems="center" spacing={2} sx={{ mt: 1, p: 2.5 }}>
            <Breadcrumbs separator="›" aria-label="breadcrumb">
              {status === 1 && (
                <Link
                  sx={{ textDecoration: 'none', cursor: 'pointer' }}
                  color="inherit"
                  onClick={() => setStatus(1)}
                >
                  <Typography
                    underline="hover"
                    key="1"
                    color="inherit"
                    variant={status === 1 ? 'h6' : 'p'}
                  >
                    {language.commons.customer}
                  </Typography>
                </Link>
              )}
              {status === 2 && (
                <Link
                  sx={{ textDecoration: 'none', cursor: 'pointer' }}
                  color="inherit"
                  onClick={() => setStatus(2)}
                >
                  <Typography
                    underline="hover"
                    key="2"
                    color="inherit"
                    variant={status === 2 ? 'h6' : 'p'}
                  >
                    {language.commons.select_vehicle}
                  </Typography>
                </Link>
              )}
              {status === 3 && (
                <Link
                  sx={{ textDecoration: 'none', cursor: 'pointer' }}
                  color="inherit"
                  onClick={() => setStatus(4)}
                >
                  <Typography
                    key="3"
                    color="inherit"
                    variant={status === 4 ? 'h6' : 'p'}
                  >
                    {language.commons.cargo_and_tool}
                  </Typography>
                </Link>
              )}
              {status === 4 && (
                <Link
                  sx={{ textDecoration: 'none', cursor: 'pointer' }}
                  color="inherit"
                  onClick={() => setStatus(5)}
                >
                  <Typography
                    key="3"
                    color="inherit"
                    variant={status === 5 ? 'h6' : 'p'}
                  >
                    {language.commons.select_direction}
                  </Typography>
                </Link>
              )}
              {status === 5 && (
                <Typography
                  key="3"
                  color="inherit"
                  variant={status === 6 ? 'h6' : 'p'}
                >
                  {language.commons.summary}
                </Typography>
              )}
            </Breadcrumbs>
          </Stack>
        </DialogTitle>

        <DialogContent>
          <Stack alignItems="center" spacing={2} sx={{ mt: 1, p: 2.5 }}>
            {status === 1 && (
              <FormControl sx={{ width: 300, p: 2.5 }}>
                {tokenService.getUser()?.accountCategory === 'store' ? (
                  <Typography textAlign="center">
                    {customer?.customer?.title}
                  </Typography>
                ) : (
                  <Select
                    displayEmpty
                    value={selectedCustomerTitle}
                    input={<OutlinedInput />}
                    renderValue={(selected) =>
                      !selected ? (
                        <em>{language.commons.customers}</em>
                      ) : (
                        selectedCustomerTitle
                      )
                    }
                    MenuProps={MenuProps}
                    inputProps={{ 'aria-label': 'Without label' }}
                  >
                    {branches?.map((branch, index) => (
                      <MenuItem
                        onClick={() => {
                          setSelectedCustomerTitle(branch.title);
                          setSelectedCustomer(branch);
                          const active = onlyActiveLocations(branch.locations);
                          generatePermutations(active);
                        }}
                        key={index}
                        value={branch.branchID}
                      >
                        {branch?.title}
                      </MenuItem>
                    ))}
                  </Select>
                )}
              </FormControl>
            )}

            {status === 2 && (
              <>
                <FormControl sx={{ width: 300, p: 2.5 }}>
                  <ToggleButtonGroup
                    color="primary"
                    size="large"
                    orientation="vertical"
                    value={selectedCar}
                    exclusive
                    onChange={(event, nextView) => setSelectedCar(nextView)}
                  >
                    {vehicles?.length > 0 &&
                      vehicles?.map((vehicle, index) => (
                        <ToggleButton
                          key={index}
                          disabled={
                            (vehicle === 'Koli / Kargo' ||
                              vehicle === 'Ring' ||
                              vehicle === 'Su Satışı') &&
                            multipleTransport === true
                          }
                          value={
                            vehicle === 'Koli/Kargo (Ring)' ? 'Ring' : vehicle
                          }
                          aria-label="list"
                        >
                          {vehicle}
                        </ToggleButton>
                      ))}
                  </ToggleButtonGroup>
                </FormControl>

                <FormControlLabel
                  sx={{ mt: 2, justifyContent: 'center' }}
                  control={
                    <Checkbox
                      onChange={(e) => {
                        setMultipleTransport(e.target.checked);
                        setSelectedCar(null);
                      }}
                    />
                  }
                  label={language.commons.multiple_shipping}
                />
              </>
            )}

            {status === 3 && (
              <>
                <FormControl sx={{ width: 500, p: 2.5 }}>
                  {cargoList &&
                    cargoList.length > 0 &&
                    cargoList.map((x, index) => (
                      <Stack
                        key={index}
                        direction="row"
                        alignItems="center"
                        justifyContent="space-between"
                      >
                        <Typography color="inherit" variant="h6">
                          {x.cargoName}
                        </Typography>
                        <Box display="flex" alignItems="center">
                          <FormControl sx={{ width: 200, p: 2.5 }}>
                            <TextField
                              id="outlined-number"
                              label={language.commons.quantity}
                              type="number"
                              value={x?.cargoNumber}
                              onChange={() => {}}
                            />
                          </FormControl>
                          <Button
                            color="error"
                            onClick={() => {
                              const next = [...cargoList];
                              next.splice(index, 1);
                              setCargoList(next);
                            }}
                          >
                            {language.commons.remove}
                          </Button>
                        </Box>
                      </Stack>
                    ))}
                </FormControl>

                <IconButton
                  size="large"
                  onClick={() => setOpenCargoSelect(true)}
                  aria-label="Kargo Ekle"
                  sx={{
                    border: '2px solid black',
                    borderRadius: '12px',
                    backgroundColor: '#fff',
                    transition: 'background 0.2s',
                    '&:hover': {
                      backgroundColor: '#f0f4ff',
                      borderColor: 'black',
                    },
                  }}
                >
                  <AddIcon sx={{ fontSize: 32 }} />
                </IconButton>
                <Typography color="inherit">
                  {language.commons.total_number}:{' '}
                  <strong>
                    {cargoList.reduce((t, x) => t + +x.cargoNumber, 0)}
                  </strong>
                </Typography>
              </>
            )}

            {status === 4 && (
              <FormControl sx={{ width: 400, p: 2.5 }}>
                <ToggleButtonGroup
                  color="primary"
                  size="large"
                  orientation="vertical"
                  value={direction}
                  exclusive
                  onChange={(event, nextView) => setDirection(nextView)}
                >
                  {tokenService.getUser()?.accountCategory === 'mall-logistics'
                    ? mlDirections.map((x, index) => (
                        <ToggleButton
                          onClick={() => {
                            setFrom(x.from);
                            setTo(x.to);
                          }}
                          key={index}
                          value={x}
                          aria-label="list"
                        >
                          {x?.title}
                        </ToggleButton>
                      ))
                    : locations.map((x, index) => (
                        <ToggleButton
                          onClick={() => {
                            setFrom(x.from);
                            setTo(x.to);
                          }}
                          key={index}
                          value={x}
                          aria-label="list"
                        >
                          {x?.title}
                        </ToggleButton>
                      ))}
                </ToggleButtonGroup>
              </FormControl>
            )}

            {status === 5 && (
              <FormControl sx={{ width: 600, p: 2.5 }}>
                <Stack
                  direction="row"
                  alignItems="center"
                  justifyContent="space-between"
                  mb={1}
                >
                  <Typography variant="h6">
                    {language.commons.customer}:
                  </Typography>
                  <Typography>{customer?.customer.title}</Typography>
                </Stack>
                <Divider />
                <Stack
                  direction="row"
                  alignItems="center"
                  justifyContent="space-between"
                  mt={1}
                  mb={1}
                >
                  <Typography variant="h6">
                    {language.commons.direction}:
                  </Typography>
                  <Typography>{direction?.title}</Typography>
                </Stack>
                <Divider />
                <Stack
                  direction="row"
                  alignItems="center"
                  justifyContent="space-between"
                  mt={1}
                  mb={1}
                >
                  <Typography variant="h6">
                    {language.commons.transport_vehicle}:
                  </Typography>
                  <Typography>
                    {selectedCar === 'Ring' ? 'Koli/Paket (Ring)' : selectedCar}
                  </Typography>
                </Stack>
                <Divider />
                <Stack
                  direction="row"
                  alignItems="center"
                  justifyContent="space-between"
                  mt={1}
                  mb={1}
                >
                  <Typography variant="h6">
                    {language.commons.total_number}:
                  </Typography>
                  <Typography>
                    {cargoList.reduce(
                      (sum, c) => sum + (c.cargoNumber ? +c.cargoNumber : 0),
                      0
                    )}
                  </Typography>
                </Stack>
                <Divider />
                {cargoList.map((x, index) => (
                  <Stack
                    key={index}
                    direction="row"
                    alignItems="center"
                    justifyContent="space-between"
                    mt={1}
                    mb={1}
                  >
                    <span>{x.cargoName}</span>
                    <span>{x?.cargoNumber}</span>
                  </Stack>
                ))}
                <Divider />
              </FormControl>
            )}
          </Stack>
        </DialogContent>

        <DialogActions sx={{ justifyContent: 'center', mb: 2 }}>
          <Button
            variant="contained"
            size="large"
            color="ochre"
            disabled={loading}
            onClick={() => {
              if (
                status === 2 &&
                tokenService.getUser()?.accountCategory === 'store'
              )
                onCreateModal();
              else if (status !== 1) setStatus(status - 1);
              else onCreateModal();
            }}
          >
            {language.commons.goBack}
          </Button>

          {status === 5 ? (
            <>
              <Button
                variant="contained"
                size="large"
                disabled={disableCreate}
                onClick={() => createNewJob()}
              >
                {loading ? (
                  <CircularProgress size={24} color="inherit" />
                ) : (
                  'Oluştur'
                )}
              </Button>

              {/* İleri Tarihli Oluştur */}
              {/* Daha sonra açılacak */}
              {/* {tokenService.getUser()?.accountCategory === 'store' && (
                <Button
                  variant="outlined"
                  size="large"
                  disabled={disableCreate}
                  onClick={openScheduleStep1}
                  sx={{ ml: 1, color: '#3F546E', borderColor: '#A3A3A3' }}
                >
                  İleri Tarihli Oluştur
                </Button>
              )} */}
            </>
          ) : (
            <Button
              variant="contained"
              disabled={
                (tokenService.getUser()?.accountCategory === 'mall-logistics' &&
                  (selectedCustomer === null ||
                    selectedCustomer === undefined ||
                    selectedCustomer === '')) ||
                (status === 2 &&
                  (selectedCar === null ||
                    selectedCar === '' ||
                    selectedCar === undefined))
              }
              size="large"
              onClick={() => setStatus(status + 1)}
            >
              {language.commons.continue}
            </Button>
          )}
        </DialogActions>
      </Dialog>

      {/* Kargo seçimi modalı */}
      <Dialog
        open={openCargoSelect}
        onClose={() => {
          setOpenCargoSelect(false);
          setIsOtherSelected(false);
        }}
      >
        <form onSubmit={handleSubmit}>
          <DialogTitle>{language.commons.cargoSelect}</DialogTitle>
          <DialogContent>
            <FormControl sx={{ width: 300, p: 2.5 }}>
              <Select
                displayEmpty
                id="cargotitle"
                name="cargotitle"
                input={<OutlinedInput />}
                renderValue={(selected) =>
                  !selected ? (
                    <em>{language.commons.shipment_type}</em>
                  ) : (
                    selected
                  )
                }
                onChange={handleCargoChange}
                MenuProps={MenuProps}
                inputProps={{ 'aria-label': 'Without label' }}
              >
                <ListSubheader
                  sx={{
                    fontWeight: 600,
                    color: '#000',
                    fontSize: 16,
                    fontStyle: 'italic',
                  }}
                  disableSticky
                >
                  Kargo Firmaları
                </ListSubheader>
                {shipmentFirmOptions.map((firm, index) => (
                  <MenuItem key={index} value={firm}>
                    {firm}
                  </MenuItem>
                ))}

                <ListSubheader
                  sx={{
                    fontWeight: 600,
                    color: '#000',
                    fontSize: 16,
                    fontStyle: 'italic',
                  }}
                  disableSticky
                >
                  Transfer İşlemleri
                </ListSubheader>
                <MenuItem value="Geri Dönüşüm">
                  {language.components.CreateWorkOrderModal.recycling}
                </MenuItem>
                <MenuItem value="Gıda">
                  {language.components.CreateWorkOrderModal.food}
                </MenuItem>
                <MenuItem value="Transfer/Merkez Aracı (Koli)">
                  {language.components.CreateWorkOrderModal.transfer}
                </MenuItem>
              </Select>
            </FormControl>

            {isOtherSelected && (
              <FormControl sx={{ width: 300, p: 2.5 }}>
                <TextField
                  id="otherCargo"
                  label="Diğer Kargo Tipi"
                  value={otherCargo}
                  onChange={(e) => setOtherCargo(e.target.value)}
                />
              </FormControl>
            )}

            <FormControl sx={{ width: 200, p: 2.5 }}>
              <TextField id="cargonumber" name="cargonumber" label="Adet" />
            </FormControl>
          </DialogContent>
          <DialogActions>
            <Button type="submit">{language.commons.save}</Button>
          </DialogActions>
        </form>
      </Dialog>

      {/* İleri tarihli rezervasyon modalı */}
      <Dialog
        open={openFutureModal}
        onClose={() => {
          if (!loading) setOpenFutureModal(false);
        }}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>Gönderi Oluşturma İşlemi</DialogTitle>

        {futureStep === 1 ? (
          <>
            <DialogContent sx={{ pt: 1 }}>
              <Typography sx={{ mb: 2 }}>
                Bu iş emrini ileri tarihli <strong>rezervasyonlu</strong> olarak
                mı oluşturmak istiyorsunuz?
              </Typography>

              <Stack spacing={2}>
                {/* Görünen: placeholder + ikon, yazı ortalı */}
                <TextField
                  placeholder="Tarih Seçin"
                  value={futureDate ? formatTRDate(futureDate) : ''}
                  onClick={openNativeDate}
                  InputProps={{
                    readOnly: true,
                    startAdornment: (
                      <InputAdornment
                        position="start"
                        sx={{ pointerEvents: 'none' }}
                      >
                        <CalendarMonthOutlinedIcon />
                      </InputAdornment>
                    ),
                  }}
                  sx={centeredFieldSx}
                />
                <TextField
                  placeholder="Saat Seçin"
                  value={futureTime || ''}
                  onClick={openNativeTime}
                  InputProps={{
                    readOnly: true,
                    startAdornment: (
                      <InputAdornment
                        position="start"
                        sx={{ pointerEvents: 'none' }}
                      >
                        <AccessTimeOutlinedIcon />
                      </InputAdornment>
                    ),
                  }}
                  sx={centeredFieldSx}
                />

                {/* Gizli gerçek pickerlar (sağdaki native ikon yok) */}
                <input
                  ref={dateRef}
                  type="date"
                  min={todayStr()}
                  value={futureDate}
                  onChange={(e) => setFutureDate(e.target.value)}
                  style={{
                    position: 'absolute',
                    opacity: 0,
                    width: 0,
                    height: 0,
                    border: 0,
                    padding: 0,
                    margin: 0,
                  }}
                />
                <input
                  ref={timeRef}
                  type="time"
                  step="60"
                  min={timeMin}
                  value={futureTime}
                  onChange={(e) => setFutureTime(e.target.value)}
                  style={{
                    position: 'absolute',
                    opacity: 0,
                    width: 0,
                    height: 0,
                    border: 0,
                    padding: 0,
                    margin: 0,
                  }}
                />
              </Stack>
            </DialogContent>
            <DialogActions sx={{ px: 3, pb: 2 }}>
              <Button onClick={() => setOpenFutureModal(false)}>Vazgeç</Button>
              <Button
                variant="contained"
                onClick={handleFutureContinue}
                disabled={!futureDate || !futureTime || !isFutureSelected()}
              >
                Devam Et
              </Button>
            </DialogActions>
          </>
        ) : (
          <>
            <DialogContent sx={{ pt: 1 }}>
              <Typography sx={{ mb: 2 }}>
                Bu iş emri için paketi getirecek kuryenin adı, iletişim numarası
                ve araç plakasını giriniz.
              </Typography>
              <Stack spacing={2}>
                <TextField
                  label="Şoför Ad Soyad"
                  value={courierName}
                  onChange={(e) => setCourierName(e.target.value)}
                />
                <TextField
                  label="Şoför Telefon No"
                  value={courierPhone}
                  onChange={(e) => setCourierPhone(e.target.value)}
                />
                <FormControl fullWidth>
                  <Select
                    displayEmpty
                    value={courierVehicleType}
                    onChange={(e) => setCourierVehicleType(e.target.value)}
                    input={<OutlinedInput />}
                    renderValue={(selected) =>
                      !selected ? <em>Araç Tipi</em> : selected
                    }
                  >
                    {vehicleTypeOptions.map((v) => (
                      <MenuItem key={v} value={v}>
                        {v}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <TextField
                  label="Plaka No*"
                  value={courierPlate}
                  onChange={(e) =>
                    setCourierPlate(e.target.value.toUpperCase())
                  }
                />
              </Stack>
            </DialogContent>
            <DialogActions sx={{ px: 3, pb: 2 }}>
              <Button onClick={() => setOpenFutureModal(false)}>Vazgeç</Button>
              <Button
                variant="contained"
                onClick={handleFutureComplete}
                disabled={
                  !courierName ||
                  !courierPhone ||
                  !courierVehicleType ||
                  !courierPlate ||
                  loading
                }
              >
                {loading ? (
                  <CircularProgress size={20} color="inherit" />
                ) : (
                  'Tamamla'
                )}
              </Button>
            </DialogActions>
          </>
        )}
      </Dialog>
    </>
  );
}
